import { NaturezaDto } from "src/app/pagamento/models/natureza-dto";

export const NATUREZA_DTO: NaturezaDto[] = [
  { codigo: 1, descricao: "PAGAMENTO/DEPÓSITO" },
  { codigo: 2, descricao: "CANCELAMENTO" },
  { codigo: 3, descricao: "CORREÇÃO DE" },
  { codigo: 4, descricao: "CORREÇÃO PARA" },
  { codigo: 5, descricao: "COMPENSAÇÃO SIAFI" },
  { codigo: 6, descricao: "PAGAMENTO COM UTILIZAÇÃO DE TÍTULOS PÚBLICOS" },
  { codigo: 8, descricao: "DARF COMPENSADO COM PRECATÓRIO" },
  { codigo: 9, descricao: "TESTE" },
];